import React from "react";

import styles from './styles.module.scss'

const TractionLogo = () => <div className={styles.logoWrp} />

export default React.memo(TractionLogo);
